/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Error_GenerateInputs */

const en_salary_negotiate_error_generate = /** @type {(inputs: Salary_Negotiate_Error_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate negotiation script.`)
};

const de_salary_negotiate_error_generate = /** @type {(inputs: Salary_Negotiate_Error_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhandlungsskript konnte nicht generiert werden.`)
};

const fr_salary_negotiate_error_generate = /** @type {(inputs: Salary_Negotiate_Error_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de générer le script de négociation.`)
};

const es_salary_negotiate_error_generate = /** @type {(inputs: Salary_Negotiate_Error_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo generar el guión de negociación.`)
};

const it_salary_negotiate_error_generate = /** @type {(inputs: Salary_Negotiate_Error_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione dello script di negoziazione non riuscita.`)
};

const nl_salary_negotiate_error_generate = /** @type {(inputs: Salary_Negotiate_Error_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderhandelingsscript genereren mislukt.`)
};

const pl_salary_negotiate_error_generate = /** @type {(inputs: Salary_Negotiate_Error_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wygenerować skryptu negocjacyjnego.`)
};

const fi_salary_negotiate_error_generate = /** @type {(inputs: Salary_Negotiate_Error_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuvotteluskriptin luominen epäonnistui.`)
};

const da_salary_negotiate_error_generate = /** @type {(inputs: Salary_Negotiate_Error_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke generere forhandlingsscript.`)
};

const sv_salary_negotiate_error_generate = /** @type {(inputs: Salary_Negotiate_Error_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte generera förhandlingsmanus.`)
};

/**
* | output |
* | --- |
* | "Failed to generate negotiation script." |
*
* @param {Salary_Negotiate_Error_GenerateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_error_generate = /** @type {((inputs?: Salary_Negotiate_Error_GenerateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Error_GenerateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_error_generate(inputs)
	if (locale === "fr") return fr_salary_negotiate_error_generate(inputs)
	if (locale === "es") return es_salary_negotiate_error_generate(inputs)
	if (locale === "it") return it_salary_negotiate_error_generate(inputs)
	if (locale === "nl") return nl_salary_negotiate_error_generate(inputs)
	if (locale === "pl") return pl_salary_negotiate_error_generate(inputs)
	if (locale === "fi") return fi_salary_negotiate_error_generate(inputs)
	if (locale === "da") return da_salary_negotiate_error_generate(inputs)
	if (locale === "sv") return sv_salary_negotiate_error_generate(inputs)
	return en_salary_negotiate_error_generate(inputs)
});